import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface AirmarAnalyticsSettingsApiModel {
    googleTrackingTypeComputed?: string;
    googleTrackingAccountId?: string;
    GoogleTrackingTypeComputed?: string;
    GoogleTrackingAccountId?: string;
}

const analyticsSettingsUrl = "api/v1/AirmarSystemSettings/analyticsSettings";

// eslint-disable-next-line require-await
export async function getAirmarAnalyticsSettings(parameter: ApiParameter = {}) {
    return get<AirmarAnalyticsSettingsApiModel>(analyticsSettingsUrl, parameter);
}